import { useDocumentSnapshot } from './useDocumentSnapshot';
import { Seeker } from '../documents/seeker';
import { Collections } from '../collections';

export const useSeekerDocumentSnapshot = (seekerId?: string): Readonly<Seeker> | undefined => {
  return useDocumentSnapshot<Readonly<Seeker>>(Collections.SEEKERS, seekerId);
};
